import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const KEY = "ecu_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // A saved browser decision belongs to the visitor, not the static HTML snapshot.
    if (navigator.userAgent === "ReactSnap") return;
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setVisible(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] bg-brand-surface/95 backdrop-blur-xl border border-slate-800 shadow-[0_0_40px_rgba(0,0,0,0.6)]"
        >
          <div className="p-6">
            <div className="flex items-start justify-between gap-4 mb-3">
              <div className="flex items-center gap-2 text-brand">
                <Cookie size={18} />
                <span className="font-mono text-xs uppercase tracking-[0.2em]">Cookies</span>
              </div>
              <button data-testid="cookie-close" onClick={() => decide("dismissed")} className="text-white/40 hover:text-white transition-colors">
                <X size={16} />
              </button>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Wir verwenden Cookies, um unsere Website und deine Erfahrung zu verbessern.
              Details findest du in unserer{" "}
              <a href="/datenschutz" className="text-brand hover:underline">Datenschutzerklärung</a>.
            </p>
            <div className="flex gap-3 mt-5">
              <button
                data-testid="cookie-accept"
                onClick={() => decide("accepted")}
                className="flex-1 bg-brand hover:bg-brand-light text-white font-semibold py-3 px-5 border border-brand-light/40 transition-colors hover:shadow-[0_0_20px_rgba(0,85,255,0.4)] uppercase tracking-wider text-xs"
              >
                Akzeptieren
              </button>
              <button
                data-testid="cookie-reject"
                onClick={() => decide("rejected")}
                className="flex-1 bg-transparent hover:bg-white/5 text-white font-semibold py-3 px-5 border border-slate-700 transition-colors uppercase tracking-wider text-xs"
              >
                Ablehnen
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
